import {PropertyLineModel, PropertyLineQuery} from './property-line.model';
import {Type} from 'class-transformer';
import {BaseIdModel, BaseIdQuery} from 'common-shared';

export class PropertyHeaderModel extends BaseIdModel {
  TypeClv?: any;
  @Type(() => PropertyLineModel)
  PropertyLines: PropertyLineModel[] = [];

  static getLine(PropertyHeader: PropertyHeaderModel, propertyId: string): PropertyLineModel {
    return (PropertyHeader || new PropertyHeaderModel()).PropertyLines.find(value => value.PropertyId === propertyId);
  }
}

export class PropertyHeaderQuery extends BaseIdQuery {
  @Type(() => PropertyLineQuery)
  PropertyLines: PropertyLineQuery[] = [];
}
